var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegratedStorytelling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 67.733 67.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 1,
    strokeDashoffset: 37.795,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.756,
    transform: "translate(.605 3.11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.715 48.938c-4.979.798-8.215 1.42-8.215 1.42v150.355s28.334-5.356 51.607-5.356c23.272 0 51.6 9.648 51.606 9.649h.002c.006-.001 28.334-9.649 51.605-9.649 23.274 0 51.608 5.356 51.608 5.356V50.357s-3.236-.62-8.215-1.42V188.74s-26.078-4.931-47.5-4.931c-21.42 0-47.493 9.223-47.498 9.224h-.002s-26.079-9.224-47.498-9.224c-21.422 0-47.5 4.931-47.5 4.931z",
    transform: "scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5 43.537c-20.049 0-45.715 4.412-45.715 4.412V191.75s26.548-4.412 45.715-4.412c19.167 0 42.5 7.984 42.5 7.984s23.333-7.984 42.5-7.984 45.713 4.412 45.713 4.412v-134a46.44 46.44 0 01-4.234 3.639c-14.905 11.225-30.112 25.045-30.112 25.045a5.67 5.67 0 01-1.61 1.02 5.67 5.67 0 01-.398 1.189s-2.63 5.61-6.363 11.699c-1.867 3.044-4.013 6.229-6.4 9.043-2.388 2.814-4.863 5.385-8.533 6.836-5.662 2.238-11.872 2.189-16.985 1.933-1.446-.072-1.383-.156-2.592-.273-.016.3.014.258-.008.568-.277 3.938-.56 8.647-3.853 12.955-3.256 4.26-7.69 6.048-11.559 7.723-3.525 1.526-6.074 2.3-6.6 2.465a5.67 5.67 0 01-.097.037 5.67 5.67 0 01-.428.162 5.67 5.67 0 01-.11.037 5.67 5.67 0 01-7.353-5.41 5.67 5.67 0 01.451-2.201l.014-.037a5.67 5.67 0 01.14-.301c.13-.307 7.224-17.11 17.298-37.258 9.069-18.138 20.215-38.616 31.322-52.22C142.265 46.46 128 51.52 128 51.52s-22.451-7.983-42.5-7.983z",
    transform: "matrix(.26458 0 0 .26458 -.605 -3.11)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 2,
    d: "M30.288 36.142s7.645-18.108 13.681-24.547c6.036-6.438 18.158-7.293 18.158-7.293s-2.967 7.759-6.991 10.79c-4.024 3.03-8.073 6.714-8.073 6.714l-5.03-3.106 4.15 4.162s-2.666 5.684-4.83 6.54c-2.162.855-6.11.175-6.11.175s.206 3.102-.73 4.326c-.936 1.224-4.225 2.239-4.225 2.239z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegratedStorytelling);
export default __webpack_public_path__ + "static/media/integrated_storytelling.989b4d4c033a891228af3d2a12fc9ec8.svg";
export { ForwardRef as ReactComponent };